import React, { FC, MouseEvent, Dispatch, Fragment } from 'react';
import styled from '@emotion/styled';
import { PlottedSeries } from '../../../interfaces/Charts';

const Line = styled.path`
  stroke-width: 1px;
  stroke-linecap: round;
  stroke-opacity: 0.75;
  fill: none;
  &:hover {
    stroke-opacity: 0.9;
    stroke-width: 2px;
  }
`;

interface LinesProps {
  series: PlottedSeries[];
  onMouseMove: (ev: MouseEvent<SVGPathElement>, line: PlottedSeries) => void;
  onMouseLeave: Dispatch<void>;
}

const Lines: FC<LinesProps> = props => {
  return (
    <Fragment>
      {props.series.map(line => {
        return (
          <Line
            onMouseMove={ev => props.onMouseMove(ev, line)}
            onMouseOut={() => props.onMouseLeave()}
            id={line.key}
            key={line.key}
            d={line.descriptor}
            stroke={line.color || 'black'}
          ></Line>
        );
      })}
    </Fragment>
  );
};

export { Lines };
